'use client';

import { AccountCard } from '@eliadmin/core/src/components/nt/account/shell/account-card';
import { ProfileTextField } from '@eliadmin/core/src/components/nt/account/profile/profile-fields';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { CheckoutTexts } from '@eliadmin/core/src/utils/nt/checkout';

/**
 * „Údaje o firme“ of a company customer (`company_buy`). The profile frame shows a private person;
 * the fields, placeholder and hint are those of the checkout's company data (172:14847).
 */
export function CompanyCard({ checkoutTexts }: { checkoutTexts: CheckoutTexts }) {
  const { t } = useTranslations();

  return (
    <AccountCard title={t('text689')}>
      <div className="grid items-start gap-4 @[36rem]:grid-cols-2">
        <ProfileTextField
          name="company"
          label={t('text1188')}
          required
          autoComplete="organization"
          placeholder={checkoutTexts.companyPlaceholder || undefined}
          className="@[36rem]:col-span-2"
        />
        <ProfileTextField name="ico" label={t('text42')} required inputMode="numeric" />
        <ProfileTextField name="dic" label={t('text43')} required />
        <ProfileTextField
          name="ic_dph"
          label={t('text44')}
          hint={checkoutTexts.icDphHint || undefined}
        />
      </div>
    </AccountCard>
  );
}
